__turbopack_context__.v({
  "root": "AddNewSessionModal-module-scss-module__n0gjFG__root",
  "root_buttonBox": "AddNewSessionModal-module-scss-module__n0gjFG__root_buttonBox",
  "root_buttonBox_cancel": "AddNewSessionModal-module-scss-module__n0gjFG__root_buttonBox_cancel",
  "root_buttonBox_save": "AddNewSessionModal-module-scss-module__n0gjFG__root_buttonBox_save",
});
